import { render, staticRenderFns } from "./KomadresSettings.vue?vue&type=template&id=175f50dc&"
import script from "./KomadresSettings.vue?vue&type=script&lang=js&"
export * from "./KomadresSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports